import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button/Button';
import './DateRangeCalendar.css';
export type DateRange = { start: string; end: string };
const key = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export function DateRangeCalendar({ value, onApply }: { value: DateRange; onApply: (range: DateRange) => void }) {
  const { t, i18n } = useTranslation();
  const [month, setMonth] = useState(() => new Date(value.start ? `${value.start}T12:00:00` : Date.now()));
  const [range, setRange] = useState(value);
  const [choosingEnd, setChoosingEnd] = useState(false);
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const offset = (first.getDay() + 6) % 7;
  const count = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  return <div className="date-range-calendar">
    <div className="date-range-calendar__heading">
      <button type="button" aria-label={t('historyFilters.previous')} onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))}>‹</button>
      <strong aria-live="polite">{month.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })}</strong>
      <button type="button" aria-label={t('historyFilters.next')} onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))}>›</button>
    </div>
    <div className="date-range-calendar__grid">
      {Array.from({ length: 7 }, (_, i) => <small key={`weekday${i}`}>{new Date(2024, 0, 1 + i).toLocaleDateString(i18n.language, { weekday: 'short' })}</small>)}
      {Array.from({ length: offset }, (_, i) => <span key={`blank${i}`} />)}
      {Array.from({ length: count }, (_, i) => {
        const date = new Date(month.getFullYear(), month.getMonth(), i + 1); const day = key(date);
        return <button type="button" key={day} aria-label={date.toLocaleDateString(i18n.language, { dateStyle: 'full' })}
          aria-pressed={!!range.start && day >= range.start && day <= range.end} aria-current={day === key(new Date()) ? 'date' : undefined}
          onKeyDown={event => {
            const delta = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
            if (delta === undefined) return;
            event.preventDefault();
            const buttons = Array.from(event.currentTarget.parentElement!.querySelectorAll<HTMLButtonElement>('button'));
            buttons[Math.max(0, Math.min(count - 1, i + delta))]?.focus();
          }}
          onClick={() => {
            if (!choosingEnd) { setRange({ start: day, end: day }); setChoosingEnd(true); }
            else { setRange({ start: day < range.start ? day : range.start, end: day < range.start ? range.start : day }); setChoosingEnd(false); }
          }}>{i + 1}</button>;
      })}
    </div>
    <p aria-live="polite">{range.start && `${new Date(`${range.start}T12:00:00`).toLocaleDateString(i18n.language)} – ${new Date(`${range.end}T12:00:00`).toLocaleDateString(i18n.language)}`}</p>
    <Button variant="secondary" disabled={!range.start} onClick={() => onApply(range)}>{t('historyFilters.apply')}</Button>
  </div>;
}
